import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of, throwError } from "rxjs";
import { catchError, finalize, first, flatMap, map } from "rxjs/operators";
import { AppSettings } from "../../../utils/app-settings";
import { loaderExemptedUrls } from "../../../utils/loader-exempted-urls";
import { passthroughUrls } from "../../../utils/passthrough-urls";
import { LoaderService } from "../../loader/loader.service";
import { LocalStorageService } from "../../local-storage-service/local-storage.service";
import { WardsService } from "../../wards-service/wards.service";


@Injectable()
export class WebHttpInterceptor implements HttpInterceptor {

    constructor(private loaderService: LoaderService
        , private localStorageService: LocalStorageService
        , private wardsService: WardsService
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (localStorage.getItem('ACCOUNT_TYPE') == "EMPLOYEE") {
            window.location.href = "/employee/";
            return;
        }
        if (passthroughUrls.indexOf(req.url) != -1) {
            return next.handle(req).pipe(
                catchError((err: any) => {
                    if (err instanceof HttpErrorResponse) {
                        if (err.status == 401) {
                            window.location.href = "/Login.aspx";
                        }
                    }
                    return of(err);
                })
            );
        }
        else {
            let headers = {};
            let request_pipeline_observable = this.wardsService.ward$.pipe(
                first(),
                map((res) => {
                    headers['studentid'] = this.localStorageService.getItem(AppSettings.LocalStorageUserContextKey).student_id;
                })
            )
            if (loaderExemptedUrls.indexOf(req.url) == -1) {
                this.loaderService.requestStart();
            }
            return request_pipeline_observable.pipe(
                flatMap(res => {
                    const dupReq = req.clone({
                        setHeaders: headers
                    });
                    return next.handle(dupReq)
                }),
                catchError((err: any) => {
                    if (err instanceof HttpErrorResponse) {
                        if (err.status == 401) {
                            window.location.href = "/Login.aspx";
                            return of(null);
                        }
                    }
                    return throwError(err.error);
                }),
                finalize(() => {
                    if (loaderExemptedUrls.indexOf(req.url) == -1) {
                        this.loaderService.requestComplete();
                    }
                })
            );
        }
    }
}